<template>
    <!-- <transition name="fade"> -->
        <div ref="tooltip" class="tooltip" :class="style" v-if="content && show" :style="{ top: top + 'px', left: left + 'px' }">
            <div v-html="content"></div>
            <div class="tooltip-tip"></div>
        </div>
    <!-- </transition> -->
</template>

<script>
import events from '../../events/events';

const settings = () => {
    return {
        content: '',
        show: false,
        top: 0,
        left: 0,
        style: '',
    };
};

export default
{
    name: 'Tooltip',

    data: settings,

    created()
    {
        events.$listen('tooltip.show', payload =>
        {
            this.content = payload.content;
            this.show = true;

            this.$nextTick(() =>
            {
                this.getBestPosition(payload.trigger, this.$refs.tooltip);
            });
        });

        events.$listen('tooltip.hide', () =>
        {
            this.reset();
        });
    },

    methods:
    {
        coordinates(el)
        {
            var rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            return { top: rect.top + scrollTop, left: rect.left + scrollLeft, width: rect.width, height: rect.height, rect: rect }
        },

        reset() 
        {
            Object.assign(this.$data, settings());
        },

        getBestPosition(tr, to)
        {
            let trigger = this.coordinates(tr),
                tooltip = this.coordinates(to),
                topTop = trigger.top - tooltip.height - 10,
                topMiddle = trigger.top + (trigger.height / 2) - (tooltip.height / 2),
                topBottom = trigger.rect.bottom + 10,
                leftLeft = trigger.left - tooltip.width - 10,
                leftMiddle = trigger.left + (trigger.width / 2) - (tooltip.width / 2),
                leftRight = trigger.rect.right + 10,
                top = topTop,
                left = leftMiddle,
                vCenter = false,
                hCenter = false,
                style = 'is-top';

            // Is top or bottom bouncing?
            if (topTop < 0) {
                if (topBottom + tooltip.height + 10 >= window.innerHeight) {
                    top = topMiddle;
                    vCenter = true;
                } else {
                    top = topBottom;
                    style = 'is-bottom';
                }
            } else {
                // Use top
                top = topTop;
                style = 'is-top';
            }

            // Is left or right bouncing?
            if (leftMiddle < 0 || leftMiddle + tooltip.width + 10 >= window.innerWidth) {
                if (leftLeft >= 0) {
                    left = leftLeft;
                    style = 'is-left';
                } else if (leftMiddle + tooltip.width + 10 <= window.innerWidth) {
                    left = leftRight;
                    style = 'is-right';
                }

                if (topMiddle + tooltip.height + 10 >= window.innerHeight) {
                    top = topMiddle - (tooltip.height / 2) - 20;
                    style = '';
                } else if (topMiddle < 0) {
                    top = topMiddle + (tooltip.height / 2) + 20;
                    style = '';
                } else {
                    top = topMiddle;
                }

                vCenter = true;
            } else {
                if (vCenter) {
                    left = leftLeft;
                }
            }

            // All bad? Use top left
            if (vCenter && hCenter) {
                left = 0;
                top = 0;
                style = '';
            }

            this.top = top;
            this.left = left;
            this.style = style;
        }
    }
}
</script>



// WEBPACK FOOTER //
// Tooltip.vue?3e5035c6